var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H6C4.1 2 2.5 3.6 2.5 5.5V18.5C2.5 20.4 4.1 22 6 22H15.6716C16.202 22 16.7107 21.7893 17.0858 21.4142L21.9142 16.5858C22.2893 16.2107 22.5 15.702 22.5 15.1716V5.5C22.5 3.6 20.9 2 19 2ZM13.5 17H12.5C11.9477 17 11.5 16.5523 11.5 16C11.5 15.4477 11.9477 15 12.5 15C13.0523 15 13.5 15.4477 13.5 16M13.5 13C12.3954 13 11.5 12.1046 11.5 11V8C11.5 7.44772 11.9477 7 12.5 7C13.0523 7 13.5 7.44772 13.5 8V12M16.5607 18.9393C16.1692 19.3308 15.5 19.0535 15.5 18.5C15.5 16.6 17.1 15 19 15C19.5535 15 19.8307 15.6693 19.4393 16.0607L16.5607 18.9393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertActive);
export default __webpack_public_path__ + "static/media/alert-active.18a1ca2cd1af210c4ba5d02a3686a872.svg";
export { ForwardRef as ReactComponent };